import React from "react";
import {
  DeploymentRequestListPageContent,
  DeploymentRequestListPageStateProvider,
} from ".";

export const DeploymentRequestListPage = () => {
  return (
    <>
      <DeploymentRequestListPageStateProvider>
        <DeploymentRequestListPageContent></DeploymentRequestListPageContent>
      </DeploymentRequestListPageStateProvider>
    </>
  );
};
